export interface KayipCiroSatiri { gun: string; fire_tutar: number; ciro_tutar: number }

/**
 * 🔴 Oranın İKİ tarafı da aynı pencereden toplanır, SONRA bölünür.
 * Günlük oranların ortalaması alınamaz: fire'sız gün 0, cirosuz gün tanımsız verir ve
 * 990065 bilerek her iki tür günü de döndürür (FULL OUTER — payda %6,2 kaybı bu yüzden yok).
 */
export function kayipCiroOrani(satirlar: KayipCiroSatiri[]) {
  let fire = 0; let ciro = 0;
  for (const s of satirlar) { fire += Number(s.fire_tutar) || 0; ciro += Number(s.ciro_tutar) || 0; }
  return { fire, ciro, oran: ciro > 0 ? (100 * fire) / ciro : null };
}

export interface KovaSatiri { kova: string; parti_sayisi: number; kalan_miktar: number; kalan_deger: number }

const KOVA_SIRASI = ['0-29 gün', '30-59 gün', '60-89 gün'] as const;
const DOKSAN_ARTI = ['90-179 gün', '180+ gün'] as const;

/**
 * D2 — 990043 beş kova döndürür (`0-29 / 30-59 / 60-89 / 90-179 / 180+`), ekran dört gösterir.
 * Son ikisi '90+ gün' altında toplanır. SQL'e dokunulmaz: 131g guard'ı 990043 ↔ 990044 kova
 * adlarını birebir eşit tutuyor, orada değiştirmek guard'ı kırar.
 */
export function kovalariBirlestir(satirlar: KovaSatiri[]): KovaSatiri[] {
  const bul = (ad: string) => satirlar.find((s) => s.kova === ad);
  const cikti: KovaSatiri[] = [];
  for (const ad of KOVA_SIRASI) { const s = bul(ad); if (s) cikti.push(s); }
  const ustler = DOKSAN_ARTI.map(bul).filter((s): s is KovaSatiri => !!s);
  if (ustler.length > 0) {
    cikti.push({
      kova: '90+ gün',
      parti_sayisi: ustler.reduce((t, s) => t + (Number(s.parti_sayisi) || 0), 0),
      kalan_miktar: ustler.reduce((t, s) => t + (Number(s.kalan_miktar) || 0), 0),
      kalan_deger: ustler.reduce((t, s) => t + (Number(s.kalan_deger) || 0), 0),
    });
  }
  return cikti;
}

/** S6 — Σpay / Σpayda. Satır oranlarının ortalaması DEĞİL. */
export function oranTopla<T>(satirlar: T[], pay: keyof T, payda: keyof T): number | null {
  let p = 0; let q = 0;
  for (const s of satirlar) { p += Number(s[pay]) || 0; q += Number(s[payda]) || 0; }
  return q > 0 ? p / q : null;
}

/** S6 — ürün tanesindeki ds'i kategoriye indirger; oran her kategoride Σpay/Σpayda. */
export function kategoriyeTopla<T extends { kategori: string }>(
  satirlar: T[], pay: keyof T, payda: keyof T,
): { kategori: string; pay: number; payda: number; oran: number | null }[] {
  const harita = new Map<string, { pay: number; payda: number }>();
  for (const s of satirlar) {
    const k = harita.get(s.kategori) ?? { pay: 0, payda: 0 };
    k.pay += Number(s[pay]) || 0;
    k.payda += Number(s[payda]) || 0;
    harita.set(s.kategori, k);
  }
  return [...harita.entries()].map(([kategori, v]) => ({
    kategori, pay: v.pay, payda: v.payda, oran: v.payda > 0 ? v.pay / v.payda : null,
  }));
}
